import Amplify from "aws-amplify";
import awsConfigurations from "./amplifyConfig";
import { getDataFromS3, getObjectListBySuffix } from "./storage";

const initializeAmplify = () => {
	Amplify.configure(awsConfigurations);
};

export default initializeAmplify;
export { getDataFromS3, getObjectListBySuffix };
